<template>
  <dl class="modal__uploaderror">
    <dt class="modal__uploaderror_title">
      {{ this.message }}
    </dt>
    <dd class="modal__uploaderror_descr">
      <p
        class="modal__uploaderror_para"
        v-if="errorType === 0"
        v-html="this.config.lang['ebrief.error.upload_error_type0_praelist0']"
      ></p>
      <ul class="modal__uploaderror_filenames">
        <li v-for="filename in displayed" class="modal__uploaderror_item">
          <span class="modal__uploaderror_itemfilename">{{ filename }}</span>
        </li>
        <li v-if="this.count > 3" class="modal__uploaderror_item">
          &hellip; und {{ this.allFilesSize - 3 }} weitere
        </li>
      </ul>
      <p
        class="modal__uploaderror_para"
        v-if="errorType === 0"
        v-html="this.config.lang['ebrief.error.upload_error_type0_suflist0']"
      ></p>
    </dd>
  </dl>
</template>
<script>
export default {
  name: "UploadError",
  props: {
    configdata: {
      type: Object,
      default: () => ({})
    },
    errorCount: {
      type: Number,
      default: 0
    },
    errorMessage: {
      type: String,
      default: ""
    },
    errorFiles: {
      type: Array,
      default: () => []
    },
    errorType: {
      type: Number,
      default: 0
    }
  },
  computed: {
    config: function () {
      return configdata;
    },
    count: function () {
      return this.errorCount;
    },
    message: function () {
      return this.errorMessage;
    },
    files: function () {
      return this.errorFiles;
    },
    allFilesSize: function () {
      return Object.keys(this.errorFiles).length;
    },
    displayed: function () {
      return this.files.slice(0, 3);
    }
  }
};
</script>
